import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen grid place-items-center bg-background p-8">
      <div className="max-w-md w-full border border-border bg-card p-10 rounded-sm text-center" data-testid="payment-cancel-page">
        <XCircle className="w-12 h-12 mx-auto text-muted-foreground" />
        <h1 className="font-display text-2xl font-bold mt-6">Checkout canceled</h1>
        <p className="text-sm text-muted-foreground mt-3">
          No charges were made. You can return to pricing at any time.
        </p>
        <Link to="/#pricing">
          <Button className="mt-8 rounded-sm bg-primary hover:bg-primary/90 w-full h-11" data-testid="back-to-pricing">
            Back to pricing
          </Button>
        </Link>
      </div>
    </div>
  );
}
